import { faApple, faAndroid } from "@fortawesome/free-brands-svg-icons";

import {
  faAngleDown,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faArrowToBottom,
  faBan,
  faBed,
  faBinoculars,
  faCalendar,
  faChartScatter,
  faCheck,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faCircleNotch,
  faClock,
  faClipboardListCheck,
  faCog,
  faCommentDots,
  faEdit,
  faEllipsisH,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkSquareAlt,
  faFileChartPie,
  faFileContract,
  faFileTimes,
  faHome,
  faHourglassHalf,
  faInfoCircle,
  faLink,
  faList,
  faLocation,
  faMapMarkedAlt,
  faMapMarkerPlus,
  faMobile,
  faPaperclip,
  faPaperPlane,
  faPencil,
  faPlus,
  faPlusCircle,
  faPrint,
  faSearch,
  faShare,
  faSignOutAlt,
  faSteeringWheel,
  faStream,
  faSort,
  faSortUp,
  faSortDown,
  faTable,
  faTachometer,
  faTimes,
  faTimesCircle,
  faToggleOff,
  faToggleOn,
  faTools,
  faTrash,
  faTruck,
  faTruckRamp,
  faUser,
  faUsers,
  faUsersCog,
  faUserClock,
  faUserHardHat,
  faUserSlash,
  faUnlink,
  faVectorSquare,
  faQuestionCircle,
  IconDefinition,
} from "@fortawesome/pro-light-svg-icons";

import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import React from "react";
import styled from "styled-components";

import * as Color from "~/Color";

export type Props = Omit<FontAwesomeIconProps, "icon" | "color"> & {
  readonly color?: Color.Color;
  readonly faded?: boolean;
};

namespace Icon {
  export const Component = styled(({ faded, ...props }) => (
    <FontAwesomeIcon {...props} />
  ))<Props>`
    height: unset;
    ${({ color }) => (color ? `color: ${color};` : "")}
    ${({ faded }) => (faded ? `opacity: 0.5;` : "")}
  `;
}

export function FixedWidth(props: { readonly children?: Component.Children }) {
  return <FixedWidth.Container {...props} />;
}

export namespace FixedWidth {
  export const Container = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.7em;
  `;
}

const toComponent = (icon: IconDefinition): Component<Props> => (props) => (
  <Icon.Component
    {...props}
    icon={icon}
    className={classNames("anticon", props.className)}
  />
);

export const AngleDown = toComponent(faAngleDown);
export const AngleUp = toComponent(faAngleUp);
export const ArrowLeft = toComponent(faArrowLeft);
export const ArrowRight = toComponent(faArrowRight);
export const Apple = toComponent(faApple);
export const Android = toComponent(faAndroid);
export const Ban = toComponent(faBan);
export const Bed = toComponent(faBed);
export const Binoculars = toComponent(faBinoculars);
export const Calendar = toComponent(faCalendar);
export const ChartScatter = toComponent(faChartScatter);
export const Check = toComponent(faCheck);
export const CheckCircle = toComponent(faCheckCircle);
export const ChevronLeft = toComponent(faChevronLeft);
export const ChevronRight = toComponent(faChevronRight);
export const ChevronDown = toComponent(faChevronDown);
export const CircleNotch = toComponent(faCircleNotch);
export const ClipboardListCheck = toComponent(faClipboardListCheck);
export const Clock = toComponent(faClock);
export const Cog = toComponent(faCog);
export const CommentDots = toComponent(faCommentDots);
export const Edit = toComponent(faEdit);
export const Ellipsis = toComponent(faEllipsisH);
export const ExclamationCircle = toComponent(faExclamationCircle);
export const ExclamationTriangle = toComponent(faExclamationTriangle);
export const ExternalLinkSquareAlt = toComponent(faExternalLinkSquareAlt);
export const FileChartPie = toComponent(faFileChartPie);
export const FileContract = toComponent(faFileContract);
export const FileTimes = toComponent(faFileTimes);
export const FileDownload = toComponent(faArrowToBottom);
export const Home = toComponent(faHome);
export const Info = toComponent(faInfoCircle);
export const Link = toComponent(faLink);
export const List = toComponent(faList);
export const Location = toComponent(faLocation);
export const MapMarkedAlt = toComponent(faMapMarkedAlt);
export const MapMarkerPlus = toComponent(faMapMarkerPlus);
export const Mobile = toComponent(faMobile);
export const PaperClip = toComponent(faPaperclip);
export const PaperPlane = toComponent(faPaperPlane);
export const Pencil = toComponent(faPencil);
export const Pending = toComponent(faHourglassHalf);
export const Plus = toComponent(faPlus);
export const PlusCircle = toComponent(faPlusCircle);
export const Print = toComponent(faPrint);
export const Search = toComponent(faSearch);
export const Share = toComponent(faShare);
export const SignOut = toComponent(faSignOutAlt);
export const SteeringWheel = toComponent(faSteeringWheel);
export const Stream = toComponent(faStream);
export const Sort = toComponent(faSort);
export const SortUp = toComponent(faSortUp);
export const SortDown = toComponent(faSortDown);
export const Table = toComponent(faTable);
export const Tachometer = toComponent(faTachometer);
export const Times = toComponent(faTimes);
export const TimesCircle = toComponent(faTimesCircle);
export const ToggleOff = toComponent(faToggleOff);
export const ToggleOn = toComponent(faToggleOn);
export const Tools = toComponent(faTools);
export const Trash = toComponent(faTrash);
export const Truck = toComponent(faTruck);
export const TruckRamp = toComponent(faTruckRamp);
export const Unlink = toComponent(faUnlink);
export const User = toComponent(faUser);
export const Users = toComponent(faUsers);
export const UsersCog = toComponent(faUsersCog);
export const UserClock = toComponent(faUserClock);
export const UserHardHat = toComponent(faUserHardHat);
export const UserSlash = toComponent(faUserSlash);
export const VectorSquare = toComponent(faVectorSquare);
export const QuestionCircle = toComponent(faQuestionCircle);
